import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import cx from 'classnames';

import * as styles from "./pagination.module.scss";

function Pagination(props) {
  const { base, currentPage, totalPages } = props

  const displayItem = (i, array) => {
    array.push(
      <Link
        aria-disabled={currentPage === i + 1}
        className={cx({
          [styles.currentPage]:(currentPage === i + 1),
          [styles.page]: true,
          'raleway-md': true,
        })}
        key={`pagination-number${i + 1}`}
        to={i === 0 ? `/${base}/` : `/${base}/page/${i + 1}/`}
      >
        {i + 1}
      </Link>
    );
  }

  const paginate = () => {
    let html = []
    if (totalPages <= 6) {
      Array.from({ length: totalPages }, (_, i) => displayItem(i, html))
    } else if (currentPage < 5) {
      Array.from({ length: 5 }, (_, i) => displayItem(i, html))
      html.push(<div className={styles.paginationDot}>. . .</div>)
      displayItem(totalPages - 1, html)
    } else if (currentPage > 4 && currentPage < totalPages - 3) {
      displayItem(0, html)
      html.push(<div className={styles.paginationDot}>. . .</div>)
      for (let i = currentPage - 3; i < currentPage + 2; i++) {
        displayItem(i, html)
      }
      html.push(<div className={styles.paginationDot}>. . .</div>)
      displayItem(totalPages - 1, html)
    } else {
      displayItem(0, html)
      html.push(<div className={styles.paginationDot}>. . .</div>)
      for (let i = totalPages - 5; i < totalPages; i++) {
        displayItem(i, html)
      }
    }
    return html
  }

  return (
    <div className={styles.paginationWrapper}>
      {paginate()}
    </div>
  );
}

Pagination.propTypes = {
  base: PropTypes.string.isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default Pagination;
